import { Button, PresetThemes } from '@travelnest/merlin.button';
import { Rule } from '@travelnest/merlin.rule';
import * as React from 'react';
import { PasswordResetError } from '../../../../errors/passwordResetError';
import {
	Form,
	FormError,
	FormInput,
	FormLabel,
	FormRow,
} from '../../../components/form';
import { Content } from '../../../components/page/content/Content';
import { resetPasswordMessage } from './helpers';

interface IResetPassState {
	email: string;
}

interface IResetPassProps {
	failure: boolean;
	error: PasswordResetError;
	loading: boolean;
	onSubmit: (email: string) => any;
}

export class ResetPasswordComponent extends React.Component<
	IResetPassProps,
	IResetPassState
> {
	public readonly state = { email: '' };

	public componentDidMount() {
		this.setState({ email: '' });
		document.title = 'Reset Password | Travelnest';
	}

	public render() {
		const state = this.state || ({} as IResetPassState);
		const email = ((value: string) => this.setState({ email: value })).bind(
			this
		);
		const submit = () => {
			this.props.onSubmit(state.email);
		};

		return (
			<>
				<Content>
					<h1 className="login__title-text">Reset Password</h1>
					<Rule />
					<p>
						Please enter your email address for your Travelnest
						account.
					</p>

					<Form
						onSubmit={(e) => e.preventDefault()}
						data-matomo-form
						data-matomo-name="customerpasswordreset"
						name="customerpasswordreset"
					>
						<FormRow>
							<FormLabel htmlFor="email">Email address</FormLabel>
							<FormInput
								data-matomo-mask
								onChange={(e) => email(e.target.value)}
								name="email"
								id="email"
							/>
						</FormRow>
						{this.props.error && this.props.error.code && (
							<FormError>
								{resetPasswordMessage(this.props.error.code)}
							</FormError>
						)}
						<p>
							<Button
								buttonType={PresetThemes.Primary}
								disabled={this.props.loading}
								loading={this.props.loading}
								onClick={() => submit()}
							>
								Send reset Code
							</Button>
						</p>
					</Form>
				</Content>
			</>
		);
	}
}
